'use client';

import React, { useState, useEffect } from "react";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Divider from '@mui/material/Divider';
import axios from "axios";
import Select from 'react-select';
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { useToast } from "../ui/ToastContext";
import { useLocation } from "react-router-dom";
import { API_URL } from "../../config";

type RoleData = {
    institution_id: number;
    description: string;
    institute_group_id: number;
    iggroup: string;
    is_active: boolean;
    institute_type_id: number;
    tip: string;
};

export function InstitutionEditForm(): React.JSX.Element {
    const { showToast } = useToast();
    const location = useLocation();
    const { item: initialData } = location.state || {};
    const [selectedEdit, setSelectedEdit] = useState(initialData);
    const [selectedEditRowData, setSelectedEditRowData] = useState<RoleData | null>(null);

    const [tip, setTip] = useState([]);
    const [group, setGroup] = useState([]);
    const [Nume_prenume, setNume_prenume] = useState("");
    const [valuetip, setValuetip] = React.useState<OptionTip[] | null>(null);
    const [valuegroup, setValuegroup] = React.useState<OptionGroup[] | null>(null);
    const [nameError, setnameError] = useState(false);
    const [tipError, settipError] = useState(false);
    const [groupError, setgroupError] = useState(false);
    const [isGroupMenuOpen, setIsGroupMenuOpen] = useState(false);
    const [showGrid, setShowGrid] = useState(true); // Stare pentru a controla ce să afișezi
    const [isActive, setIsActive] = useState(false);
    const getJwtFromCookies = () => {
        const cookies = document.cookie.split("; ");
        const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
        return tokenCookie ? tokenCookie.split("=")[1] : null;
    };
    //const token = getJwtFromCookies();
  const [user, setUser] = useState(null);

    const token = localStorage.getItem('jwtToken');


    useEffect(() => {
        const timer = setTimeout(() => {
            setShowGrid(false); // După 1 secundă, comutăm pe grid
        }, 1000);
        return () => clearTimeout(timer);
    }, []);

    
    useEffect(() => {
        axios
            .get(`${API_URL}/api/tipinstitution`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setTip(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    useEffect(() => {
        axios
            .get(`${API_URL}/api/grupinstitution`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                // //////////////////////////////console.log("rrrrrrrrrrrrr", response.data);
                setGroup(response.data);
            })
            .catch((error) => {
                console.error("Error fetching data:", error);
            });
    }, []);

    interface OptionTip {
        institute_type_id: number;
        description: string;
    }

    const organizerOptionstip: OptionTip[] = tip.map((role: OptionTip) => ({
        institute_type_id: role.institute_type_id,
        description: role.description,
    }));

    interface OptionGroup {
        institute_group_id: number;
        description: string;
    }

    const organizerOptionsGroup: OptionGroup[] = group.map((role: OptionGroup) => ({
        institute_group_id: role.institute_group_id,
        description: role.description,
    }));


    useEffect(() => {
        axios
            .get(`${API_URL}/api/institutions`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                const user = response.data.find(item => item.institution_id === selectedEdit.institution_id);
                setSelectedEditRowData(user);
                //////////////////////////console.log(user)
                if (user) {
                    setNume_prenume(user.description);
                    setIsActive(user.is_active);

                    const matchedTip = organizerOptionstip.find((i) => i.institute_type_id === user.institute_type_id);
                    setValuetip(matchedTip ? [matchedTip] : null);

                    const matchedGroup = organizerOptionsGroup.find((i) => i.institute_group_id === user.institute_group_id);
                    setValuegroup(matchedGroup ? [matchedGroup] : null);

                }
            })
            .catch((error) => {
                console.error("Error fetching user data:", error);
            });
    }, [selectedEdit, group, tip]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (Nume_prenume === ""

            || !valuetip || valuetip.length === 0
            || !valuegroup || valuegroup.length === 0
        ) {
            setnameError(Nume_prenume === "" ? true : false);

            settipError(!valuetip || valuetip?.length === 0 ? true : false);
            setgroupError(!valuegroup || valuegroup?.length === 0 ? true : false);

            //////////////////////////////console.log("Error: Fields are empty or invalid.");
            return;
        }

        try {
            if (valuetip && valuetip.length > 0) {
                for (let tipId of valuetip) {
                    if (valuegroup && valuegroup.length > 0) {
                        for (let groupId of valuegroup) {
                            //////////////////////////////console.log(producerId1.district_id);
                            //////////////////////////////console.log(producerId.city_id);
                            await axios
                                .put(
                                    `${API_URL}/api/changeinstitutions/${selectedEditRowData?.institution_id}`,
                                    {
                                        description: Nume_prenume,
                                        institute_type_id: tipId.institute_type_id,
                                        institute_group_id: groupId.institute_group_id,
                                        is_active: isActive ? 1 : 0,
                                    }
                                )
                        }
                    }
                }
            }

            showToast({
                message: "Datele au fost salvate cu succes!",
                type: "success",
                icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
            });
        } catch (error) {
            console.error(error);
            showToast({
                message: "Eroare la inserarea datelor!",
                type: "error",
                icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
            });
        }
    };

    const handleChange = (e) => {
        setNume_prenume(e.target.value);
    };

    const handleClick = () => {
        setIsActive(!isActive);
    }

    const isDarkMode = document.documentElement.classList.contains('dark');

    return (
        <div >
            {showGrid ? (
                <div className="flex flex-row gap-2">
                    <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
                    <div className="flex flex-col gap-2">
                        <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
                        <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
                    </div>
                </div>
            ) : (
                <form
                    onSubmit={(event) => {
                        event.preventDefault();
                    }}
                >
                    <Card className="p-2 dark:bg-gray-800 dark:text-gray-100">
                        <CardHeader
                            subheader="Informatia poate fii modificata"
                            title="Formular"
                            subheaderTypographyProps={{ style: { fontSize: "0.875rem", color: "#B0B0B0" } }}
                            action={
                                <button
                                    className={`px-4 py-2 rounded-md text-sm font-semibold ${isActive === true
                                        ? "bg-green-700 text-white"
                                        : "bg-gray-500 text-white"
                                        }`}
                                    onClick={handleClick}
                                >
                                    {isActive === true ? "Activ" : "Inactiv"}
                                </button>
                            } />
                        <Divider className="dark:bg-gray-400" />
                        <CardContent>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
                                <div className="relative">
                                    <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10" >
                                        Grupul de institutii
                                    </label>
                                    <Select
                                        options={organizerOptionsGroup}
                                        placeholder="Select grup..."
                                        classNamePrefix="react-select"
                                        value={valuegroup}
                                        onChange={(selected) => {
                                            //////////////////////////////console.log("Selected value:", selected);
                                            setValuegroup(selected ? [selected] : null); // Asigură-te că value este întotdeauna un array
                                        }}

                                        getOptionLabel={(e) => e.description}
                                        getOptionValue={(e) => String(e.institute_group_id)}
                                        menuPortalTarget={document.body}
                                        onMenuOpen={() => setIsGroupMenuOpen(true)}
                                        onMenuClose={() => setIsGroupMenuOpen(false)}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                padding: '0.75rem',
                                                borderRadius: '0.375rem',
                                                borderColor: groupError ? 'red' : '#424242',
                                                boxShadow: 'none',
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                                zIndex: 0,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                                color: isDarkMode ? 'black' : base.backgroundColor,
                                            }),
                                            singleValue: provided => ({
                                                ...provided,
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                            })
                                        }}
                                    />
                                    {groupError && <p className="text-red-500 text-sm">Grupul este obligatoriu.</p>}
                                </div>

                                <div className="relative">
                                    {isGroupMenuOpen || (
                                        <label className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 z-10dark:text-gray-100 z-10">
                                            Tip de institutie
                                        </label>
                                    )}
                                    <Select
                                        options={organizerOptionstip}
                                        placeholder="Select tipul..."
                                        classNamePrefix="react-select"
                                        value={valuetip}
                                        onChange={(selected) => {
                                            //////////////////////////////console.log("Selected value:", selected);
                                            setValuetip(selected ? [selected] : null); // Asigură-te că value este întotdeauna un array
                                        }}

                                        getOptionLabel={(e) => e.description}
                                        getOptionValue={(e) => String(e.institute_type_id)}
                                        menuPortalTarget={document.body}

                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                                padding: '0.75rem',
                                                borderRadius: '0.375rem',
                                                borderColor: tipError ? 'red' : '#424242',
                                                boxShadow: 'none',
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                                backgroundColor: isDarkMode ? '#1f2937' : provided.backgroundColor,
                                                zIndex: 0,
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Z-index mare pentru a depăși dialogul
                                                color: isDarkMode ? 'black' : base.backgroundColor,
                                            }),
                                            singleValue: provided => ({
                                                ...provided,
                                                color: isDarkMode ? '#FFFFFF' : '#1F2937',
                                            })
                                        }}
                                    />
                                    {tipError && <p className="text-red-500 text-sm">Tipul este obligatoriu.</p>}

                                </div>
                            </div>

                            <div className="relative mt-5">
                                <label
                                    className="absolute -top-3 left-2 text-sm bg-white px-1 dark:bg-gray-800 dark:text-gray-100"
                                >
                                    Denumirea institutie
                                </label>
                                <input
                                    className={`w-full p-3 border rounded-md dark:bg-gray-800 dark:text-gray-100 focus:ring-2 focus:ring-blue-500 ${nameError ? 'border-red-500' : ''}`}
                                    type="text"
                                    name="firstName"
                                    placeholder="Denumirea"
                                    value={Nume_prenume}
                                    onChange={handleChange}
                                />
                                {nameError && <p className="text-red-500 text-sm">Denumirea este obligatorie.</p>}

                            </div>
                        </CardContent>
                        <Divider className="dark:bg-gray-400" />
                        <CardActions sx={{ justifyContent: 'flex-end' }}>
                            <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white" onClick={handleSubmit}>
                                <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                                </svg>
                                <span className="//max-xs:sr-only">Salveaza detaliile</span>

                            </button>
                        </CardActions>
                    </Card>
                </form>
            )}
        </div>
    );
}
